import React from 'react'
import { Dialog, Heading, Icon, Text } from '@plurall/elo-beta'
import PropTypes from 'prop-types'

import styles from './ModalPending.module.scss'

const RenderTitle = () => (
  <div className={styles.dialogTitle}>
    <Icon size='big' variant='informative' secondary type='Info-circle' />
    <Heading className={styles.title} element='h4'>
      Sobre a função escolhida
    </Heading>
  </div>
)

const ModalPending = ({ setIsModalOpen, trySubmitRoles }) => (
  <Dialog
    title={<RenderTitle />}
    primaryButtonText='Confirmar'
    secondaryButtonText='Cancelar'
    onPrimaryClick={() => trySubmit(setIsModalOpen, trySubmitRoles)}
    onSecondaryClick={() => cancelSubmit(setIsModalOpen)}
    onClose={() => cancelSubmit(setIsModalOpen)}
    size='medium'
  >
    <Text size='t3' dimmed>
      As funções Administrador e Diretor precisam de aprovação do gestor para serem ativadas. Assim
      que for aprovado, você será notificado por e-mail.
    </Text>
  </Dialog>
)

const cancelSubmit = setIsModalOpen => setIsModalOpen(false)
const trySubmit = (setIsModalOpen, trySubmitRoles) => {
  trySubmitRoles()
  setIsModalOpen(false)
}

ModalPending.propTypes = {
  setIsModalOpen: PropTypes.func.isRequired,
  trySubmitRoles: PropTypes.func.isRequired,
}

export default ModalPending
